import { matchRoutes, type RouteObject } from 'react-router-dom'
import { seoNavigationPathPattern } from '../../platform/pwa/navigation-fallback'

export function resolveStoryNavigation(
  routes: RouteObject[],
  path: string,
): 'spa' | 'document' | null {
  if (seoNavigationPathPattern.test(path)) return 'document'
  const matches = matchRoutes(routes, path)
  return matches && !matches.some((match) => match.route.path === '*')
    ? 'spa'
    : null
}
